"use client";

import { useRef, useEffect, ReactNode } from "react";
import { useHeaderHeight } from "@/app/providers/navigationProvider";
import useMediaQuery from "@/utils/useMediaQuery";

export default function ShopLayoutClient({
  children,
  footer,
}: Readonly<{
  children: ReactNode;
  footer: ReactNode;
}>) {
  const mainRef = useRef<HTMLElement>(null);
  const { headerHeight, previousHeight, recalculateHeight } = useHeaderHeight();
  const hasLayoutChanged = useMediaQuery("(max-width: 640px)");

  useEffect(() => {
    if (mainRef.current) {
      if (headerHeight >= previousHeight) {
        mainRef.current.style.paddingTop = `${headerHeight}px`;
      }

      mainRef.current.style.scrollPaddingTop = `${headerHeight}px`;
    }
  }, [headerHeight]);

  useEffect(() => {
    if (hasLayoutChanged && mainRef.current) {
      recalculateHeight();
    }
  }, [hasLayoutChanged, headerHeight]);

  return (
    <main
      ref={mainRef}
      className="flex flex-col items-center flex-1 overflow-scroll w-full bg-[#FBFBFB]"
    >
      <div className="flex-1 flex flex-col w-full mx-0">{children}</div>
      <footer className="w-full">{footer}</footer>
    </main>
  );
}
